'use client';

import posthog from 'posthog-js';

let isInitialized = false;

export function initPostHog(): typeof posthog | null {
  if (typeof window === 'undefined') {
    return null;
  }

  if (isInitialized) {
    return posthog;
  }

  const apiKey = process.env.NEXT_PUBLIC_POSTHOG_KEY;
  if (!apiKey) {
    return null;
  }

  posthog.init(apiKey, {
    api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST || 'https://ext.boty.bot',
    defaults: '2026-01-30',
    person_profiles: 'identified_only',
    capture_pageview: false,
    capture_pageleave: true,
    persistence: 'localStorage+cookie',
    // Error tracking — autocapture exceptions (Story 16.2)
    capture_exceptions: true,
    loaded: (posthogInstance) => {
      if (process.env.NODE_ENV === 'development') {
        posthogInstance.debug();
      }
    },
  });

  isInitialized = true;
  return posthog;
}

export function getPostHog(): typeof posthog | null {
  if (!isInitialized) {
    return null;
  }
  return posthog;
}

export { posthog };
